/**
 * 	 JS V2 MODAL
 */

module.exports = () => {
  const togglers = cube.$$('.modalv2__toggler');

  togglers.forEach(toggler => {
    toggler.addEventListener('change', e => {
      if(e.target.checked) {
        cube.$id('main-container').style.zIndex = 'inherit';
        cube.event.send('modalOpen', e.target.id);
      }
      else {
        cube.$id('main-container').style.zIndex = null;
        cube.event.send('modalClose', e.target.id);
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-modal-v2.js